module.exports = __webpack_public_path__ + "img/paper.edeaac58.png";